module.exports = __webpack_public_path__ + "img/normal_multiplier_2.e07fee5a.png";